angular.module('rightPaneModule')
  .controller('DistrictSchoolsController', [
      '$scope',
      'districtApi',
      'schoolApi',
      '$state',
      'tableColumns',
      'tableSort',
      'timeframe',
      'authentication',
      'edxReportItemService',
      'edxTimeframeListService',
      'reportErrors',
      function (
        $scope,
        districtApi,
        $schoolApi,
        $state,
        $tableColumns,
        $tableSort,
        timeframe,
        dblAuthentication,
        edxReportItemService,
        edxTimeframeListService,
        $reportErrors) {

      // Set to true once we've subscribed to our Angular event to avoid subscribing twice
      var areEventsSubscribed = false;

      var updateMode = function() {
          $scope.listTableColumns = $tableColumns.getColumns('school_fractions');

          var defaultColumn = $tableSort.getDefaultColumn($scope.listTableColumns);
          $scope.activeMetric = $state.params.sort || defaultColumn || $scope.listTableColumns[0];
      };

      updateMode();

      $scope.defaultMetric = 'percent_growth';


      $scope.years = {list: null, selected: {}};

      var timeframeIds = ['7d', '30d'];
      var defaultTimeframeId = '30d';
      $scope.timeframes = edxTimeframeListService.buildTimeframes(timeframeIds, defaultTimeframeId);

      var initializeGraphData = function () {
          if (!$state.params.timeframe) {
              timeframe.updateStateParams($scope.timeframes.selected.id, $scope.timeframes.selected.by)
                .then(function () {
                    updateSchools();
                    updateFrequencyData();
                    updateHighlights();
                });
          } else {
              updateSchools();
              updateFrequencyData();
              updateHighlights();
          }
      };

      var updateFrequencyData = function () {
          $scope.schoolsFrequencyError = null;
          $scope.frequencyData = undefined;
          $schoolApi.getSchoolsFrequency().then(function (data) {
              $scope.frequencyData = data;
          }, function(error) {
              $scope.schoolsFrequencyError = $reportErrors.getErrorMessage(error);
          });
      };

      var updateSchools = function () {
          $scope.schoolsReportingUrl = $schoolApi.getSchoolsReportingExportUrl();
          $scope.schoolsError = null;
          $scope.listTableData = undefined;
          $schoolApi.getSchoolsReporting().then(function (data) {
              $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, data);
          }, function (error) {
              $scope.listTableData = undefined;
              $scope.schoolsError = $reportErrors.getErrorMessage(error);
          });
      };

      var updateTableSort = function () {
          if ($scope.listTableData) {
              $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, $scope.listTableData);
          }
      };

      var updateSchoolsPaging = function (e, page) {
          $state.current.data.page = page;

          $scope.listTableData = undefined;
          $schoolApi.getSchoolsReporting().then(function (data) {
              if (!$scope.listTableData) {
                  $scope.listTableData = [];
              }
              var uniqueList = _.uniq($scope.listTableData.concat(data), false, function (li) {
                  return li.id;
              });
              $scope.listTableData = uniqueList;
          });
      };

      var updateHighlights = function () {
          var params = _.pick($state.params, ['districtId']);
          params = _.extend(params, timeframe.getTimeframeParams());

          $scope.districtData = undefined;
          districtApi.getDistrictHighlights(params).then(function (districtData) {
              $scope.districtData = districtData;
          });
      };

      var updateData = function () {
          updateMode();
          updateSchools();
          updateFrequencyData();
          updateHighlights();
      };

      var initializeData = function(item) {
          // Note that initially $scope.item === item because item is set on a parent scope!!
          // Once we set $scope.item = item then we have our own item reference which can be different from the parent
          if (!_.eq($scope.item, item) || !areEventsSubscribed) {
            $scope.item = item;
            initializeGraphData();
          }

          // We never want to subscribe to events multiple times or else we will receive each event multiple times
          if (!areEventsSubscribed) {
            $scope.$on('updateSortableTable', updateTableSort);

            $scope.$on('yearSelected', updateData);

            $scope.$on('listTableNextPage', updateSchoolsPaging);

            $scope.$on('timeframeSelected', updateData);

            $scope.$on('listTableRowClicked', function (e, item) {
              $scope.$emit('route', item);
            });

            areEventsSubscribed = true;
          }
      };

      var itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(function (item) {
          initializeData(item);
      });

      var timeframeSubscription = timeframe.getYearListSubject().subscribe(function (years) {
          $scope.years.list = angular.copy(years);
      });

      $scope.$on('$destroy', function () {
          itemSubscription.dispose();
          timeframeSubscription.dispose();
      });
  }]);
